import React, { useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window } from "../../components/VB";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function AjukanIzin() {
  const today = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({ tanggal: today, jenis: "Sakit", keterangan: "", bukti_path: "" });
  const [busy, setBusy] = useState(false);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/izin", form);
      toast.success("Izin berhasil diajukan");
      navigate("/karyawan/izin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  const uploadBukti = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setForm({ ...form, bukti_path: data.path });
      toast.success("Bukti berhasil diupload");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setUploading(false);
  };

  return (
    <Window title="Ajukan Izin">
      <div style={{ background: "#FFFFE1", border: "1px solid #828790", padding: 8, marginBottom: 10, fontSize: 12 }}>
        <strong>Aturan:</strong> Maksimal 2 kali izin per bulan kalender.
      </div>
      <form onSubmit={submit} style={{ maxWidth: 500 }}>
        <div className="vb-form-row">
          <label className="vb-label">Tanggal Izin*</label>
          <input type="date" className="vb-input" value={form.tanggal} onChange={(e) => setForm({ ...form, tanggal: e.target.value })} required data-testid="izin-tanggal" />
        </div>
        <div className="vb-form-row">
          <label className="vb-label">Jenis Izin*</label>
          <select className="vb-select" value={form.jenis} onChange={(e) => setForm({ ...form, jenis: e.target.value })} required data-testid="izin-jenis">
            <option>Sakit</option><option>Keperluan Pribadi</option><option>Cuti</option><option>Lainnya</option>
          </select>
        </div>
        <div className="vb-form-row">
          <label className="vb-label">Keterangan*</label>
          <textarea rows={3} className="vb-textarea" value={form.keterangan} onChange={(e) => setForm({ ...form, keterangan: e.target.value })} required data-testid="izin-ket" />
        </div>
        <div className="vb-form-row">
          <label className="vb-label">Upload Bukti (opsional)</label>
          <input type="file" accept="image/*,application/pdf" onChange={uploadBukti} disabled={uploading} className="vb-input" data-testid="izin-bukti" />
          {form.bukti_path && <span style={{ fontSize: 11, color: "#4f8a10" }}>✓ Bukti terupload</span>}
        </div>
        <div style={{ marginTop: 12, textAlign: "right" }}>
          <button type="submit" className="vb-btn-primary" disabled={busy} data-testid="izin-submit">
            {busy ? "Memproses..." : "Ajukan Izin"}
          </button>
        </div>
      </form>
    </Window>
  );
}
